module.exports = __webpack_public_path__ + "static/img/44.9ef7cf36.png";